export default __webpack_public_path__ + "static/media/sorted.sorted_filtered_0.33AED_renamed.gon1_assembled_potato.all.gff.5d623209.gz";